// src/pages/Accounting/Reports/AccountList/constants.ts

import type { ReportColumnDef, ReportCustomization } from './types';

export const PALETTE = {
  ink: '#0E1A1A',
  ink2: '#263238',
  ink3: '#3A4A52',
  ink4: '#6B7684',
  line: '#D8DEE6',
  lineSoft: '#E7EAF0',
  panel: '#F7F8FA',
  sage: '#EDF2EE',
  teal: '#15A08C',
  tealDark: '#0F6E56',
  vela: '#A855F7',
  velaDeep: '#4C1D95',
  velaFade: '#F5F3FF',
};

export const DEFAULT_COLUMNS: ReportColumnDef[] = [
  { key: 'accountName', label: 'Account Name', align: 'left', sortable: true, defaultVisible: true },
  { key: 'type', label: 'Type', align: 'left', sortable: true, defaultVisible: true },
  { key: 'detailType', label: 'Detail type', align: 'left', sortable: true, defaultVisible: true },
  { key: 'description', label: 'Description', align: 'left', sortable: false, defaultVisible: true },
  { key: 'totalBalance', label: 'Total balance', align: 'right', sortable: true, defaultVisible: true },
];

export const AVAILABLE_COLUMNS: Array<{ key: keyof import('./types').AccountListRow; label: string }> = [
  { key: 'accountName', label: 'Account Name' },
  { key: 'type', label: 'Type' },
  { key: 'detailType', label: 'Detail type' },
  { key: 'description', label: 'Description' },
  { key: 'totalBalance', label: 'Total balance' },
];

export const FILTER_FIELDS = [
  { value: 'deleted', label: 'Deleted' },
  { value: 'accountName', label: 'Account Name' },
  { value: 'type', label: 'Type' },
  { value: 'detailType', label: 'Detail type' },
];

export const FILTER_CONDITIONS = [
  { value: 'equals', label: 'equals' },
  { value: 'notEquals', label: 'does not equal' },
  { value: 'contains', label: 'contains' },
  { value: 'startsWith', label: 'starts with' },
];

export const ZOOM_LEVELS = [50, 75, 100, 125, 150, 200];
export const DENSITIES: Array<{ value: 'compact' | 'standard' | 'spacious'; label: string }> = [
  { value: 'compact', label: 'Compact' },
  { value: 'standard', label: 'Standard' },
  { value: 'spacious', label: 'Spacious' },
];

export const SCHEDULE_FREQUENCIES: Array<{ value: 'daily' | 'weekly' | 'monthly' | 'custom'; label: string }> = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'custom', label: 'Custom' },
];

export const DEFAULT_CUSTOMIZATION: ReportCustomization = {
  columns: DEFAULT_COLUMNS.map((c, i) => ({ key: c.key, visible: !!c.defaultVisible, order: i })),
  filters: [],
  numberFormat: {
    divideByThousand: false,
    hideCurrencySymbol: false,
    negativeStyle: 'parentheses',
  },
  header: {
    showCompanyLogo: false,
    showCompanyName: true,
    showReportTitle: true,
    showReportPeriod: true,
    alignment: 'center',
  },
  footer: {
    showDatePrepared: true,
    showTimePrepared: true,
    alignment: 'center',
  },
  cell: {
    emptyCellStyle: 'blank',
  },
  columnColors: {},
  rowSettings: {
    bandedRowColor: '',
  },
  gridlines: {
    borderStyle: 'default',
  },
};

export const VELA_SUGGESTED_PROMPTS = [
  'Which accounts have the biggest balances?',
  'Show me all accounts with no activity this quarter',
  "What's my total expense breakdown?",
  'Any duplicates I should merge?',
];